import { enumToArray } from "@a2system/angular";
import { Installer } from "./installer.model";

export interface UserModel {
  id: string;
  displayName: string;
  firstName: string;
  lastName: string;
  email: string;
  emailVerified?: boolean;
  phoneNumber?: string;
  phoneNumberVerified?: false;
  address?: string;
  photoURL?: string;
  uid: string;
  roles: Array<UserModel.Role>;
  providerId: string;
  installer?: Installer.Reference;
  disabled?: boolean;
  stats?: UserModel.Stats;
  finalWindows: Array<string>;
  createdAt?: Date;
  updatedAt?: Date;
}

export namespace UserModel {
  export interface Stats {
  }

  export interface Claims {
    roles: Array<string>;
    installer?: string;
  }
  export const roles = ()=> enumToArray(UserModel.Role)
  //Por ahora no se usa premium, gold silver como role.
  //seguramente posteriormente lo usaremos
  export enum Role {
    ADMIN = 'admin',
    INSTALLER = 'installer',
    CLIENT = 'client',
    PREMIUM = 'premium',
    GOLD   = 'gold',
    SILVER = 'silver',
    BRONZE = 'bronze'
    // REPRESENTATIVE = 'representative'
  }
  export const create = (userData: Partial<UserModel>):UserModel  =>{
    const user:UserModel = Object.assign(
      {
        id: null,
        displayName: '',
        firstName: '',
        lastName: '',
        email: '',
        emailVerified: false,
        phoneNumber: '',
        phoneNumberVerified: false,
        address: '',
        photoURL: '',
        uid: '',
        roles: [],
        disabled: false,
        providerId: null,
        finalWindows:[]
      }, userData
    )
    return user;
  }

  export class Reference   {
    id!: string;
    displayName!: string;

    public static gen(user:UserModel){
      const {id, displayName} = user;
      return { id, displayName};
    }
  }
}
